import { Trans, useTranslation } from "react-i18next";

import { ProductCardFooterBox } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { CallsInfo } from "@/components/Portal/Cockpit/CallsInfo/CallsInfo.tsx";
import { RoamingUsage } from "@/components/Portal/Cockpit/RoamingUsage/RoamingUsage.tsx";
import { SpeedAndData } from "@/components/Portal/Cockpit/SpeedAndData/SpeedAndData.tsx";
import { DeviceProductCard } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/DeviceProductCard.tsx";
import { getIconForProductCategory } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/ProductCategoryIcon.tsx";
import { SimStatusChip } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/SimStatusChip.tsx";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims.ts";
import { useGetTitle } from "@/hooks/useGetTitle.ts";
import { getSpeedFromLocalFlatSpeed } from "@/utils/deviceUtils";

interface ActiveSimNoPackageTileProps {
  device: ExtendedSimCardDetail;
  manageRoute: string;
}

/**
 * This device tile version is used when the sim has an active roaming package
 * but no active flat rate package.
 */
export const ActiveSimNoPackageTile = ({
  device,
  manageRoute,
}: ActiveSimNoPackageTileProps) => {
  const { t } = useTranslation("portal");
  const icon = getIconForProductCategory(device);
  const title = useGetTitle(device.alias);

  return (
    <DeviceProductCard
      dataTestid="active-sim-no-package-tile"
      icon={icon}
      title={title}
      subtitle={t("layout.tiles.inactive.noPackageActive")}
      headerClassName="opacity-50"
      navigationTarget={`${manageRoute}?simId=${device.simId}`}
      chips={<SimStatusChip status={device.simStatus} />}
      footer={
        <div className="flex w-full flex-col gap-3">
          <ProductCardFooterBox>
            <SpeedAndData speed={getSpeedFromLocalFlatSpeed(device)} />
            <p className="text-body-base leading-md text-foreground-primary">
              <Trans
                t={t}
                components={[<span key={0} className="font-semibold" />]}
                i18nKey="layout.tiles.inactive.activateText"
              />
            </p>
          </ProductCardFooterBox>
          <CallsInfo device={device} />
          <RoamingUsage device={device} />
        </div>
      }
    />
  );
};
